import { Box } from "@mui/system"
import { StyledTableCell } from "components/tables/StyledTable.tsx"
import { DriverInfo, VehicleInfo } from "types/list-card-holder"
import { SortOrder, SORTORDER } from "types/sort.ts"

import ArrowDropDownRoundedIcon from "@mui/icons-material/ArrowDropDownRounded"
import ArrowDropUpRoundedIcon from "@mui/icons-material/ArrowDropUpRounded"
import { useCardHolderContext } from "layouts/card-holder/context/useCardHolderContext.ts"
import { useCallback } from "react"

export const CardHolderHeaderCell = ({
    keyDriver,
    content,
    centered = false,
    icon = null,
    width,
}: {
    keyDriver: keyof DriverInfo | keyof VehicleInfo
    content: string
    centered?: boolean
    icon?: React.ReactNode
    width: string
}) => {
    const {
        orderByDriver,
        orderByVehicle,
        sortOrder,
        setOrderByDriver,
        setOrderByVehicle,
        setSortOrder,
        isVehicle,
    } = useCardHolderContext()

    // Déterminer quel "orderBy" utiliser en fonction de isVehicle
    const currentOrderBy = isVehicle ? orderByVehicle : orderByDriver

    const onSort = useCallback(
        (orderBy: keyof VehicleInfo | keyof DriverInfo) => {
            if (isVehicle) {
                setOrderByVehicle(orderBy as keyof VehicleInfo)
            } else {
                setOrderByDriver(orderBy as keyof DriverInfo)
            }

            setSortOrder((sortOrder: SortOrder) =>
                sortOrder === SORTORDER.ASC ? SORTORDER.DESC : SORTORDER.ASC
            )
        },
        [isVehicle, setOrderByVehicle, setOrderByDriver, setSortOrder]
    )

    return (
        <StyledTableCell
            onClick={() => onSort(keyDriver)}
            sx={{
                width: width,
                cursor: "pointer",
            }}
        >
            <Box
                sx={{
                    position: "relative",
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    width:
                        currentOrderBy !== keyDriver
                            ? "calc(100% + 0.5rem)"
                            : "100%",
                    justifyContent: centered ? "center" : null,
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: "1.5em",
                    }}
                >
                    {icon}
                    {content}
                </Box>
                {currentOrderBy === keyDriver &&
                    sortOrder === SORTORDER.ASC && (
                        <ArrowDropUpRoundedIcon
                            sx={{
                                p: 0,
                                m: 0,
                                ml: "16px",
                                height: "0.5rem",
                                width: "0.5rem",
                                transform: "scale(3.5)",
                                color: "grey.600",
                            }}
                            data-testid="arrow-up-sort-table-driver"
                        />
                    )}
                {currentOrderBy === keyDriver &&
                    sortOrder === SORTORDER.DESC && (
                        <ArrowDropDownRoundedIcon
                            sx={{
                                p: 0,
                                m: 0,
                                ml: "16px",
                                height: "0.5rem",
                                width: "0.5rem",
                                transform: "scale(3.5)",
                                color: "grey.600",
                            }}
                            data-testid="arrow-down-sort-table-driver"
                        />
                    )}
            </Box>
        </StyledTableCell>
    )
}
